import { columnCenter, subTitle2, black, blackOutline, button, secondary } from '../../../../../resources/styles';
import { merge } from '../../../../../utils';

const styles = {};

styles['content'] = { width: 240, height: 240 };

styles['loader'] = merge(columnCenter, { justifyContent: 'center' });

styles['authenticating'] = merge(subTitle2, black, { marginTop: 31 });

styles['success'] = { display: 'flex', flexDirection: 'column', alignItems: 'stretch' };

styles['success_content'] = merge(columnCenter, { justifyContent: 'center', flex: 1 });

styles['success_text'] = merge(subTitle2, black, { marginTop: 20, padding: '0 25px', textAlign: 'center' });

styles['success_footer'] = merge({ width:'100%',borderTop: `1px solid ${blackOutline.color}`, padding: 12 }, button, secondary);

export default styles;